export const FILTERS_SEARCH_PARAM_PREFIX = "filters-"
export const ATTACHMENT_TYPE_FILTER = "attachment_type"
export const AUTHOR_FILTER = "author"
export const DATE_FROM_FILTER = "date_from"
export const DATE_TO_FILTER = "date_to"
export const FILE_NAME_FILTER = "file_name"
export const FILE_TYPE_FILTER = "file_type"
export const TAGS_FILTER = "documentsTags"
export const ANTITAGS_FILTER = "documentsAntiTags"
export const OBJECT_TYPE_FILTER = "attached_object_type"

export const FILTERS = [
    ATTACHMENT_TYPE_FILTER,
    AUTHOR_FILTER,
    DATE_FROM_FILTER,
    DATE_TO_FILTER,
    FILE_NAME_FILTER,
    FILE_TYPE_FILTER,
    TAGS_FILTER,
    ANTITAGS_FILTER,
]
